import { COLORS } from '@btime/constants'
import React from 'react'

import { useModalsState } from './ModalsContext'
import FlexGrid from '../structure/FlexGrid'
import ModalsActions from './ModalsActions'
import ModalsBreadcrumbs from './ModalsBreadcrumbs'
import Panel from '../structure/Panel'

const ModalsNavigation = ({ showFirst }) => {
  const { history } = useModalsState()
  if (!showFirst && history?.length <= 1) return false

  return (
    <Panel bgColor={COLORS.dark1} noMargin smallPaddingTopBottom noShadow noRadius>
      <FlexGrid justify="flex-start">
        <ModalsActions />
        <ModalsBreadcrumbs />
      </FlexGrid>
    </Panel>
  )
}

export default ModalsNavigation
